import { render, staticRenderFns } from "./processMonitoringLargeBatchRecordDetail.vue?vue&type=template&id=1ff9aff0&scoped=true"
import script from "./processMonitoringLargeBatchRecordDetail.vue?vue&type=script&lang=js"
export * from "./processMonitoringLargeBatchRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./processMonitoringLargeBatchRecordDetail.vue?vue&type=style&index=0&id=1ff9aff0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9aff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff9aff0')) {
      api.createRecord('1ff9aff0', component.options)
    } else {
      api.reload('1ff9aff0', component.options)
    }
    module.hot.accept("./processMonitoringLargeBatchRecordDetail.vue?vue&type=template&id=1ff9aff0&scoped=true", function () {
      api.rerender('1ff9aff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/processMonitoring/processMonitoringLargeBatchRecordDetail.vue"
export default component.exports